<app-dialog-header [title]="'GENERAL.BUTTON.COPY_TO_NEW'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content fxLayout="column" fxLayoutAlign="start">
    <mat-horizontal-stepper (selectionChange)="onStepChange($event)" [linear]="true" class="pt-16 copy-to-new-module-stepper" labelPosition="bottom" #stepper>
        <mat-step>
            <ng-template matStepLabel>{{ 'GENERAL.PROPERTY.NAME' | translate }}</ng-template>
            <form [formGroup]="moduleForm" class="module w-100-p">
                <div fxLayout="row" fxLayoutAlign="flex-end center">
                    <mat-form-field class="w-100-p">
                        <mat-label> {{ 'GENERAL.PROPERTY.NAME' | translate }} </mat-label>
                        <input matInput name="name" formControlName="name" />
                        <mat-error *ngIf="moduleForm.controls['name'].errors && moduleForm.controls['name'].errors['message']">
                            {{ 'ERROR.RESPONSE.' + moduleForm.controls['name'].errors['message'] | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <p class="m-0">
                    <span class="input-title">{{ 'TAG.PLURAL' | translate }}</span> ({{ 'GENERAL.PROPERTY.OPTIONAL' | translate | lowercase }})
                </p>
                <div class="w-100-p">
                    <mat-form-field class="w-100-p">
                        <input
                            matInput
                            [placeholder]="('TAG.NEW' | translate) + '...'"
                            #tagInput
                            [formControl]="tagCtrl"
                            [matAutocomplete]="auto"
                            [matChipInputFor]="chipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="true"
                            (matChipInputTokenEnd)="addTag($event)"
                        />
                    </mat-form-field>
                    <mat-chip-grid class="wrap mb-8" #chipList>
                        <div class="relative" *ngFor="let tag of moduleForm.value.tags">
                            <mat-chip-row [style.background]="tag.color" [selectable]="true" [removable]="true" (removed)="removeTag(tag)" [disableRipple]="true">
                                <span #chip>{{ tag.name }}</span>
                                <mat-icon matChipRemove>close</mat-icon>
                            </mat-chip-row>
                            <app-tag-color-card (updated)="tagUpdated($event)" [tag]="tag" [name]="tag.name" [target]="chip"> </app-tag-color-card>
                        </div>
                    </mat-chip-grid>
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="tagSelected($event)">
                        <mat-optgroup [label]="'TAG.NEW' | translate" *ngIf="!tagTermExists && tagCtrl.value">
                            <mat-option [value]="tagCtrl.value"><span [innerHTML]="tagCtrl.value | highlight: tagCtrl.value"></span></mat-option>
                        </mat-optgroup>
                        <mat-optgroup
                            [label]="('GENERAL.SUGGESTIONS' | translate) + ' (' + tags.length + ')'"
                            *ngIf="(filteredTag$ | async) || [] | exclude: moduleForm.value.tags || []:'id'; let tags"
                        >
                            <mat-option *ngFor="let tag of tags" [value]="tag">
                                <span [innerHTML]="tag.name | highlight: tagCtrl.value"></span>
                            </mat-option>
                        </mat-optgroup>
                    </mat-autocomplete>
                    <mat-hint>{{ 'PAGE.MODULE_FORM.TAB.OVERVIEW.MESSAGE.TAGS_HINT' | translate }} </mat-hint>
                </div>
            </form>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>{{ 'GENERAL.PROPERTY.DURATION' | translate }}</ng-template>
            <form [formGroup]="moduleForm" class="module w-100-p">
                <div class="mb-24 w-100-p" fxLayout="column">
                    <mat-radio-group class="self-paced-container" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="20px" formControlName="selfPaced">
                        <div
                            *ngIf="(!moduleForm.controls.selfPaced.value && moduleType === 'e_learning') || moduleType === 'basic'"
                            class="radio-wrapper"
                            [class.selected]="!moduleForm.controls.selfPaced.value"
                            fxLayout="column"
                        >
                            <mat-radio-button [value]="false"></mat-radio-button>
                            <div fxLayout="column" fxLayoutAlign="center center">
                                <img height="42" width="42" src="/assets/icons/ic_scheduled_module.svg" />
                                <span class="mt-12">{{ 'MODULE.SCHEDULED.TITLE' | translate }} </span>
                                <p>{{ 'MODULE.SCHEDULED.DESCRIPTION' | translate }}</p>
                            </div>
                        </div>
                        <div class="radio-wrapper" [class.selected]="moduleForm.controls.selfPaced.value" fxLayout="column">
                            <mat-radio-button [value]="true"></mat-radio-button>
                            <div fxLayout="column" fxLayoutAlign="center center">
                                <img height="42" width="42" src="/assets/icons/ic_self_paced_module.svg" />
                                <span class="mt-12">{{ 'MODULE.SELF_PACED.TITLE' | translate }} </span>
                                <p>{{ 'MODULE.SELF_PACED.DESCRIPTION' | translate }}</p>
                            </div>
                        </div>
                    </mat-radio-group>
                </div>
                <div *ngIf="!moduleForm.controls.selfPaced.value">
                    <div fxLayout="row" fxLayoutAlign="flex-end center">
                        <mat-form-field class="w-100-p">
                            <input
                                matInput
                                name="startDate"
                                [max]="maxDate"
                                formControlName="startDate"
                                [matDatepicker]="pickerStartDate"
                                [placeholder]="'GENERAL.PROPERTY.START_DATE' | translate"
                                (focus)="pickerStartDate.open()"
                                (ngModelChange)="updateEndDate()"
                            />
                            <mat-datepicker-toggle matSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
                            <mat-datepicker #pickerStartDate></mat-datepicker>

                            <mat-error *ngIf="moduleForm.controls['startDate'].errors && moduleForm.controls['startDate'].errors['message']">
                                {{ 'ERROR.RESPONSE.' + moduleForm.controls['startDate'].errors['message'] | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="flex-end center">
                        <mat-form-field class="w-100-p">
                            <input
                                matInput
                                name="endDate"
                                [min]="minDate"
                                formControlName="endDate"
                                [matDatepicker]="pickerEndDate"
                                [placeholder]="'GENERAL.PROPERTY.END_DATE' | translate"
                                (focus)="pickerEndDate.open()"
                                (dateChange)="updateStartDate()"
                            />
                            <mat-datepicker-toggle matSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
                            <mat-datepicker #pickerEndDate></mat-datepicker>
                            <mat-error *ngIf="moduleForm.controls['endDate'].errors && moduleForm.controls['endDate'].errors['message']">
                                {{ 'ERROR.RESPONSE.' + moduleForm.controls['endDate'].errors['message'] | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div fxLayout="column" class="mt-16" *ngIf="moduleType === 'basic'; else duration">
                    <p class="m-0">
                        <span class="input-title">{{ 'MODULE.MODULE_DURATION.TITLE' | translate }}</span> ({{ 'GENERAL.PROPERTY.OPTIONAL' | translate | lowercase }})
                    </p>
                    <p class="m-0 mb-8">
                        {{ 'MODULE.MODULE_DURATION.DESCRIPTION' | translate }}
                    </p>
                    <div fxLayout="row" fxLayoutAlign="flex-start center" class="duration-wrapper" formGroupName="digicompDuration">
                        <mat-form-field class="duration-field">
                            <input matInput min="0" type="number" name="year" step="1" [placeholder]="'GENERAL.YEAR' | translate" formControlName="y" />
                        </mat-form-field>
                        <mat-form-field class="duration-field">
                            <input matInput min="0" type="number" name="month" step="1" [placeholder]="'GENERAL.MONTH' | translate" formControlName="m" />
                        </mat-form-field>
                        <mat-form-field class="duration-field">
                            <input matInput min="0" type="number" name="week" step="1" [placeholder]="'GENERAL.WEEK' | translate" formControlName="w" />
                        </mat-form-field>
                        <mat-form-field class="duration-field">
                            <input matInput min="0" type="number" name="day" step="1" [placeholder]="'GENERAL.DAY' | translate" formControlName="d" />
                        </mat-form-field>
                        <mat-form-field class="duration-field">
                            <input matInput min="0" type="number" name="hour" step="1" [placeholder]="'GENERAL.HOUR' | translate" formControlName="hh" />
                        </mat-form-field>
                        <mat-form-field class="duration-field">
                            <input matInput min="0" type="number" name="minute" step="1" [placeholder]="'GENERAL.MINUTE' | translate" formControlName="mm" />
                        </mat-form-field>
                    </div>
                </div>
                <ng-template #duration>
                    <div fxLayout="row" fxLayoutAlign="flex-end center">
                        <mat-form-field class="w-100-p">
                            <input
                                matInput
                                [cleave]="{ time: true, timePattern: ['h', 'm'] }"
                                formControlName="duration"
                                [placeholder]="'GENERAL.PROPERTY.EXPECTED_DURATION' | translate"
                            />
                            <mat-icon class="timepicker-icon">access_time</mat-icon>
                        </mat-form-field>
                    </div>
                </ng-template>
            </form>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>{{ 'PAGE.MODULE_FORM.TAB.MANAGERS.TITLE' | translate }}</ng-template>
            <div *ngIf="stepper.selectedIndex === 2" class="select-users-wrapper" fxLayout="column" fxLayoutAlign="start">
                <ng-container *ngIf="list.length">
                    <h3 class="mb-8 text-base font-medium text-gray-600">{{ 'GENERAL.LABEL.SELECTED_USERS' | translate }}</h3>
                    <mat-chip-set class="chip-list wrap">
                        <mat-chip class="chip maxbrain-500" [removable]="removable" (removed)="removeFromList(item)" *ngFor="let item of list">
                            {{ item.fullName }}
                            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                        </mat-chip>
                    </mat-chip-set>
                </ng-container>

                <div fxLayout="row" fxLayoutAlign="flex-end center" class="mb-12">
                    <app-search-outline [searchInput]="searchInput"></app-search-outline>
                </div>

                <div class="w-100-p table-wrapper" *ngIf="dataSource">
                    <mat-table #table [dataSource]="dataSource" matSort>
                        <!-- Avatar Column -->
                        <ng-container matColumnDef="avatar">
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell *matCellDef="let user">
                                <div #avatarCell>
                                    <img class="avatar" *ngIf="user?.avatar.src; else initials" [alt]="user.fullName" [src]="user.avatar.src" />
                                    <ng-template #initials>
                                        <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                                    </ng-template>
                                </div>
                            </mat-cell>
                        </ng-container>

                        <!-- First Name Column -->
                        <ng-container matColumnDef="firstName">
                            <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header> {{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }}</mat-header-cell>
                            <mat-cell *matCellDef="let user" class="narrow">
                                <p #firstNameRow class="text-truncate font-semibold">
                                    {{ user.firstName }}
                                </p>
                            </mat-cell>
                        </ng-container>

                        <!-- Last Name Column -->
                        <ng-container matColumnDef="lastName">
                            <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header>
                                {{ 'GENERAL.PROPERTY.LAST_NAME' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let user" class="narrow">
                                <p #lastNameRow class="text-truncate font-semibold">
                                    {{ user.lastName }}
                                </p>
                            </mat-cell>
                        </ng-container>

                        <!-- Email Column -->
                        <ng-container matColumnDef="email">
                            <mat-header-cell class="wider" *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs>
                                {{ 'GENERAL.PROPERTY.EMAIL' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let user" class="wider" fxHide fxShow.gt-xs>
                                <p #lastNameRow class="text-truncate font-semibold">{{ user.email }}</p>
                            </mat-cell>
                        </ng-container>

                        <!-- Buttons Column -->
                        <ng-container matColumnDef="buttons">
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell *matCellDef="let user">
                                <div fxFlex="row" fxLayoutAlign="end center">
                                    <app-flat-button [label]="'GENERAL.BUTTON.ADD'" (onClick)="addToList(user)" *ngIf="!user.alreadyMember && !user.selected"></app-flat-button>
                                    <p *ngIf="user.alreadyMember">{{ 'GENERAL.LABEL.IN_GROUP' | translate }}</p>
                                    <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(user)" *ngIf="user.selected"></app-white-button>
                                </div>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let user; columns: displayedColumns" class="user" matRipple> </mat-row>
                    </mat-table>
                    <mat-paginator persistPageSize="module.copy-to-new-module-dialog" [length]="totalCount$ | async" [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 50]"> </mat-paginator>
                </div>
            </div>
        </mat-step>
    </mat-horizontal-stepper>
</div>
<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [disabled]="stepper.selectedIndex === 0" [label]="'GENERAL.BUTTON.PREVIOUS'" (onClick)="goBack(stepper)"></app-white-button>

    <app-white-button
        class="mr-8"
        [disabled]="!moduleForm.controls['name'].value || stepper.selectedIndex === 2"
        [label]="'GENERAL.BUTTON.NEXT'"
        (onClick)="goForward(stepper)"
    ></app-white-button>
    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" [disabled]="moduleForm.invalid" (onClick)="copyModule()"></app-flat-button>
</div>
